import { Link } from 'react-router-dom'
import styles from './Rodape.module.scss'
import logoMark from '../../assets/images/logo-mark-minha-fono.png'
import {
  NAV_LINKS,
  WHATSAPP_DISPLAY,
  INSTAGRAM_URL,
  YOUTUBE_URL,
  openWhatsApp,
} from '../constants'
import { ROUTES } from '../../appRoutes'

const SERVICOS = [
  'Fala e sons da fala',
  'Linguagem',
  'Fluência',
  'Motricidade orofacial',
  'Voz e oratória',
  'Consultoria para famílias',
]

const Rodape = () => (
  <footer className={styles.footer}>
    <div className={styles.inner}>
      <div className={styles.brandCol}>
        <div className={styles.brand}>
          <span className={styles.brandMark}>
            <img src={logoMark} alt="" aria-hidden="true" />
          </span>
          <span className={styles.brandText}>
            <strong>MINHA FONO</strong>
            <small>ONLINE</small>
          </span>
        </div>
        <p>
          Fonoaudiologia online para crianças, adolescentes e adultos. Cuidado,
          ciência e acolhimento em cada atendimento.
        </p>
        <div className={styles.social}>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <i className="material-icons">photo_camera</i>
          </a>
          <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <i className="material-icons">play_circle</i>
          </a>
        </div>
      </div>

      <div className={styles.col}>
        <h3>Navegação</h3>
        <ul>
          {NAV_LINKS.map(link => (
            <li key={link.href}>
              <a href={link.href}>{link.label}</a>
            </li>
          ))}
          <li>
            <a href="/blog/">Blog</a>
          </li>
          <li>
            <Link to={ROUTES.login}>Login</Link>
          </li>
        </ul>
      </div>

      <div className={styles.col}>
        <h3>Serviços</h3>
        <ul>
          {SERVICOS.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>

      <div className={styles.col}>
        <h3>Contato</h3>
        <ul className={styles.contact}>
          <li>
            <i className="material-icons">phone</i> {WHATSAPP_DISPLAY}
          </li>
          <li>
            <i className="material-icons">public</i> Atendimento online em todo o
            Brasil e exterior
          </li>
        </ul>
        <button type="button" className={styles.cta} onClick={openWhatsApp}>
          Agendar avaliação <i className="material-icons">chat</i>
        </button>
      </div>
    </div>

    <div className={styles.bottom}>
      <span>© 2026 Minha Fono Online. Todos os direitos reservados.</span>
    </div>
  </footer>
)

export default Rodape
